import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-2 tw-block tw-text-xs" }, " Select a web compatible font that has Regular, Medium and Bold weights ", -1)
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between tw-gap-2" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mt-2 tw-text-xs tw-text-slate-500" }, "Supported Formats - TTF, OTF, WOFF, WOFF2", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConditionalColorPicker = _resolveComponent("ConditionalColorPicker")!
  const _component_FontDropdown = _resolveComponent("FontDropdown")!
  const _component_StudioInput = _resolveComponent("StudioInput")!
  const _component_StudioButton = _resolveComponent("StudioButton")!
  const _component_FilestackS3 = _resolveComponent("FilestackS3")!
  const _component_ModuleWrapper = _resolveComponent("ModuleWrapper")!

  return (_openBlock(), _createBlock(_component_ModuleWrapper, {
    moduleId: _ctx.moduleId,
    class: "tw-relative",
    title: 'Stage Font',
    onInitializeData: _ctx.initializeData
  }, {
    main: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", null, [
        _createVNode(_component_ConditionalColorPicker, {
          id: "font-color-picker",
          label: "Font Color",
          type: "color",
          class: "tw-mb-4",
          initialColor: _ctx.desktopColor.style,
          onColorChange: _ctx.onFontColorChange
        }, null, 8, ["initialColor", "onColorChange"]),
        _createVNode(_component_FontDropdown, {
          selectedFontOption: _ctx.selectedFontOption,
          moduleId: _ctx.moduleId,
          hideFontDropdown: _ctx.hideFontDropdown,
          class: "tw-mb-4",
          onSetSelectedFontOption: _ctx.setSelectedFontOption
        }, null, 8, ["selectedFontOption", "moduleId", "hideFontDropdown", "onSetSelectedFontOption"]),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_StudioInput, {
            id: "web-font-name-input",
            ref: "webFontNameInput",
            modelValue: _ctx.custom_font_name,
            required: "",
            label: "Font Name",
            class: "tw-mb-4",
            inlineError: _ctx.fontNameInvalidError,
            "onUpdate:modelValue": _ctx.handleUpdateFontName
          }, null, 8, ["modelValue", "inlineError", "onUpdate:modelValue"]),
          _createVNode(_component_StudioInput, {
            id: "web-font-url-input",
            ref: "webFontUrlInput",
            modelValue: _ctx.theme_font_link,
            required: "",
            label: "Font URL",
            placeholder: "https://...",
            inlineError: _ctx.fontUrlInvalidError,
            "onUpdate:modelValue": _ctx.handleUpdateFontURL
          }, null, 8, ["modelValue", "inlineError", "onUpdate:modelValue"])
        ], 512), [
          [_vShow, _ctx.selectedFontOption === 'Web Font']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.themeFontSrc)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.themeFontSrc,
                  target: "_blank",
                  class: "tw-w-[300px] tw-overflow-hidden tw-overflow-ellipsis tw-text-sm"
                }, _toDisplayString(_ctx.customFontName), 9, _hoisted_3))
              : _createCommentVNode("", true),
            _createVNode(_component_FilestackS3, {
              s3path: _ctx.s3BucketPath,
              acceptedTypes: _ctx.FONT_FILE_TYPES,
              onFileuploaded: _ctx.onFileUpload
            }, {
              default: _withCtx(() => [
                _createVNode(_component_StudioButton, {
                  trackingId: "upload-font-file-button",
                  variant: _ctx.themeFontSrc ? 'outline' : 'warn'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.themeFontSrc ? 'Change File' : 'Upload File'), 1)
                  ]),
                  _: 1
                }, 8, ["variant"])
              ]),
              _: 1
            }, 8, ["s3path", "acceptedTypes", "onFileuploaded"])
          ]),
          _hoisted_4
        ], 512), [
          [_vShow, _ctx.selectedFontOption === 'Custom']
        ])
      ])
    ]),
    _: 1
  }, 8, ["moduleId", "onInitializeData"]))
}